import * as React from 'react';
import classNames from 'classnames';

export const Toggle = ({
  checked,
  ...rest
}: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>) => {
  return (
    <label
      data-toggle
      className={classNames('ui-toggle', { 'ui-toggle--active': checked, 'ui-toggle--disabled': rest.disabled })}
    >
      <input className={classNames('ui-toggle__input')} type="checkbox" checked={checked} {...rest} />
      <div className={classNames('ui-toggle__knob')}></div>
    </label>
  );
};
